import { useSelector } from 'react-redux';
import { selectIsWebview } from '../../selectors/user';
import s from './BackButton.module.css';
import { useEffect, useState } from 'react';

export function BackButton() {
  const isWebview = useSelector(selectIsWebview);
  const [hasReferer, setHasReferer] = useState(false);

  useEffect(() => {
    setHasReferer(window.history.length !== 1);
  }, []);

  if (!isWebview || !hasReferer) {
    return null;
  }

  return (
    <div className={s.wrapper}>
      <button onClick={() => history.back()} className={s.button}>
        Назад
      </button>
    </div>
  );
}
